import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "flex lg:justify-between lg:flex-row items-center flex-col"
}


import 'element-plus/lib/components/table/style/css';
import defaultProps from 'element-plus/lib/components/table/src/table/defaults';

import { StTable } from './table.styled';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkTable',
  props: {
  ...defaultProps,
  maxPerPage: {
    type: Number,
    default: 10,
  },
  totalItems: {
    type: Number,
    default: 10,
  },
  currentPage: {
    type: Number,
    default: 1,
  },
  paginate: {
    type: Boolean,
    default: false,
  },
},
  emits: ['page-change'],
  setup(__props, { emit }) {

const props = __props





const handlePageChange = (page: number) => {
  emit('page-change', page);
};

return (_ctx: any,_cache: any) => {
  const _component_ElPagination = _resolveComponent("ElPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(StTable)), _normalizeProps(_guardReactiveProps({
        ..._ctx.$attrs,
        height: props.height,
        maxHeight: props.maxHeight,
        data: props.data,
      })), _createSlots({ _: 2 }, [
      _renderList(_ctx.$slots, (_, slot) => {
        return {
          name: slot,
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope || {})))
          ])
        }
      })
    ]), 1040)),
    (props.paginate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_component_ElPagination, {
            key: props.currentPage,
            layout: "prev, pager, next",
            "current-page": props.currentPage,
            "page-size": props.maxPerPage,
            total: props.totalItems,
            onCurrentChange: handlePageChange
          }, null, 8, ["current-page", "page-size", "total"])),
          _renderSlot(_ctx.$slots, "footer-end", { class: "justify-self-end" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})